module.exports = __webpack_public_path__ + "48589f8ad4bdfcce852eba7324a5cb09.jpg";